import moment from "moment";

class GetFirstVolumeLogFromValveUseCase {
  constructor(repository) {
    this.repository = repository;
  }
  async execute(FK_SECTOR,FK_VALVE){
    const result= await this.repository.getValveFirstVolumeLog(FK_SECTOR,FK_VALVE)

    if(result.length){
      return result[0]//{}
    }
    return {
      TIME: moment().format("YYYY-MM-DD"),
      VALUE: 0
    }
  }
}
export {
  GetFirstVolumeLogFromValveUseCase,
};
